import { pdfjs } from "react-pdf";

/**
 * pdf.js needs its worker script configured once, globally, before any document is parsed.
 * Importing this module performs that setup and hands back the configured `pdfjs`, so every
 * consumer shares one worker URL rather than repeating the assignment (which is easy to
 * forget, and fails at runtime with an opaque "worker not configured" error).
 *
 * The worker ships in Client/public, so this resolves to a same-origin URL.
 */
pdfjs.GlobalWorkerOptions.workerSrc = new URL("/pdf.worker.min.js", import.meta.url).toString();

export { pdfjs };
